import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import R from 'ramda';
import CategoryBanner from '../../molecules/CategoryBanner';
import StandardLayout from '../../templates/StandardLayout';

const StoreLocatorPage = ({ sectionHeadings, advisorLink }) => (
  <StandardLayout>
    <CategoryBanner
      heading={R.prop('heading')(sectionHeadings)}
      text={R.prop('introduction')(sectionHeadings)}
    />

    <div className="grid-container">
      <div className="cell xsmall-16">
        <iframe
          className="advisor-widget"
          title="widget"
          src={advisorLink}
          frameBorder="0"
          scrolling="no"
        />
      </div>
    </div>
  </StandardLayout>
);

StoreLocatorPage.propTypes = {
  sectionHeadings: PropTypes.objectOf(PropTypes.string),
  advisorLink: PropTypes.string.isRequired,
};

export default connect(({ content }) => ({
  sectionHeadings: R.prop('sectionHeadings', content),
  advisorLink: R.prop('advisorLink', content),
}))(StoreLocatorPage);
